<template>
  <div>
    <secondHeader />
    <div class="main">
      <sidebar />
      <div class="content">
        <div class="bl_media_container">
          <div class="message">
            <h2>プレミアムコンテンツ</h2>
            <p>無料版よりもハイクオリティなツールを販売しています。</p>
          </div>
          <div
            class="bl_media_itemWrapper"
            v-for="toolKit in toolKits"
            :key="toolKit.index"
          >
              <div class="content_item">
                <img class="card-img" :src="toolKit.src" alt="" />
                <div class="media-content">
                  <h3>{{ toolKit.title }}</h3>
                  <p>{{ toolKit.description }}</p>
                  <div class="btn-area">
                    <a :href="toolKit.store" target="_blank">
                        <span class="store-btn">BOOTHで購入</span>
                    </a>
                    <router-link :to="toolKit.to">
                        <span class="custom-btn">カスタマイズ</span>
                    </router-link>
                  </div>
                </div>
              </div>
          </div>

          <div class="ad">
            <InFeedAdsense
                data-ad-layout-key="-fb+5w+4e-db+86"
                data-ad-client="ca-pub-9016794589237931"
                data-ad-slot="4898735474">
            </InFeedAdsense>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import secondHeader from "../../components/secondHeader.vue";
import sidebar from "../../components/sidebar.vue"

export default {
  components: {
    secondHeader,
    sidebar,
  },
  data() {
    return {
      isProduction: process.env.NODE_ENV === "production",
      toolKits: [
        {
          index: 1,
          type: "internal",
          src: require("@/assets/thumbnail/premium-cat2.png"),
          store:"https://takatsukisyou.booth.pm/items/5181357",
          title: "肉球コメント v2",
          to: "/premium-nyan2",
          description:"OBSで使えるコメント用のカスタムCSS。かわいい肉球とアニメーションが特徴です。",
        },
        {
          index: 2,
          type: "internal",
          src: require("@/assets/thumbnail/premium-heart.png"),
          store:"https://takatsukisyou.booth.pm/items/5181364",
          title: "ハートコメント",
          to: "/premium-heart",
          description:"OBSで使えるコメント用のカスタムCSS。ハートがアクセントのデザインです",
        },
        {
          index:3,
          type: "internal",
          src: require("@/assets/thumbnail/premium-fukidashi.png"),
          to: "/premium-fukidashi",
          store:"https://takatsukisyou.booth.pm/items/4863903",
          title: "プレミアムふきだしコメント",
          description:"OBSで使えるコメント用のカスタムCSS。無料版より作りこんだふきだしです。無料版との違いは、「改行時などのレイアウト崩れなし」「きれいなしっぽ」「アニメーション付き」「各サイトの最新の仕様に対応」です。",
        },
        {
          index: 4,
          type: "internal",
          src: require("@/assets/thumbnail/premium-glitch.png"),
          to: "/premium-nyan",
          store:"https://takatsukisyou.booth.pm/items/4919770",
          title: "プレミアムグリッチコメント",
          description:"OBSで使えるコメント用のカスタムCSS。グリッチっぽいアニメーションが特徴。小さなスペースにも使えるシンプルなデザインです。",
        },
        {
          index: 5,
          type: "internal",
          src: require("@/assets/thumbnail/premium-traslucent.png"),
          store:"https://takatsukisyou.booth.pm/items/5119454",
          title: "プレミアム半透明コメント",
          description:"OBSで使えるコメント用のカスタムCSS。半透明なふきだしでゲーム画面など、背景と合わせるのに向いています。YouTube・Twitch用とわんコメのテンプレートもあります。",
        },
        {
          index: 6,
          type: "internal",
          src: require("@/assets/thumbnail/premium-cat.png"),
          to: "/premium-nyan",
          store:"https://takatsukisyou.booth.pm/items/4856981",
          title: "肉球コメント",
          description:"OBSで使えるコメント用のカスタムCSS。かわいい肉球とアニメーションが特徴です。カラーは3種類！",
        },
      ],
    };
  },
};
</script>
<style scoped>
.main {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
  background: linear-gradient(-225deg, #acb6e5 0%, #fff 25%,#fff 75%, #FFBAC3 100%);
}

.content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 60px 0 60px 1.82%;
}

.message{
  display: block;
  width: 100%;
}

h2{
  margin: calc(30px / 2);
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

.message p{
  margin: calc(30px / 2);
}

h3 {
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

img {
  width: 100%;
  vertical-align: bottom;
}
.card-img {
  object-fit: contain;
  height: auto;
  width: 30%;
  /* overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0,0,0,.2); */
}

/* .card-img img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
} */
.bl_media_container {
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  max-width: 1080px;
  padding: 30px;
}
.bl_media_itemWrapper {

  margin: calc(30px / 2);
}

.content_item {
  display: flex;
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 4px rgb(0 0 0 / 5%);
  color: #000000;
  text-decoration: none;
}

.content_item {
  /* display: flex; */
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 4px rgb(0 0 0 / 5%);
  color: #000000;
  text-decoration: none;
}

.bl_media_item:hover {
  transform: translateY(-5px);
  box-shadow: 0 7px 34px rgba(50,50,93,.1), 0 3px 6px rgb(0 0 0 / 5%);
  transition: all .5s;
}

.media-content{
  padding-left: 12px;
}

.bl_media_itemWrapper a {
  text-decoration: none;
}
.bl_media_item p {
  font-size: 14px;
}


@media screen and (max-width: 756px) {
  .custom-btn, .store-btn {
    display:block;
    margin:auto;
  }
}


.store-btn {
  color: #fff;
  background-color: #eb6100;
  padding: 5px 16px;
  border-radius: 8px;
    letter-spacing: 1px;
  box-shadow: 0 2px 4px rgb(0 0 0 / 5%);
  margin-right:12px;
  margin-top:12px;
}
.store-btn:hover,
a.store-btn:hover {
  color: #fff;
  background: #f56500;
}

.custom-btn {
  color: #fff;
  background-color: #9CB4CC;
  padding: 5px 16px;
  border-radius: 8px;
    letter-spacing: 1px;
  box-shadow: 0 2px 4px rgb(0 0 0 / 5%);
  margin-right:12px;
  margin-top:12px;
}
.custom-btn:hover,
a.custom-btn:hover {
  color: #fff;
  background: #B2C8DF;
}

.ad-block{
  padding: 12px 0px;
  display: block;
  width: 100%;
}
.ad {
  max-height: 300px;
  max-width: 70%;
  margin: 0 auto;
  padding-bottom: 24px;
  text-align: center;
  box-sizing: border-box;
}



</style>